import { useTheme, Box, Table, TableContainer, TableHead, TableBody, TableRow, TableCell, Paper, List, Typography } from "@mui/material";
import { StyledBox } from "../../components/StyledBox";
import { StyledListItem } from "../../components/StyledListItem";

export interface CredentialInformationProps{
    credentials: {
        credentialId?: string,
        credentialType?: string,
        description?: string,
        issueDate?: string,
        firstName?: string,
        lastName?: string,
        middleName?: string
    },
    isLegacy?: boolean
}

const CredentialInformation: React.FC<CredentialInformationProps> = ({credentials, isLegacy}) =>{
    const theme = useTheme();

    return(
        <StyledBox>
            <TableContainer component={Paper}>
                <Table sx={{border: `${theme.spacing(1/8)} solid ${theme.palette.common.black}`}} size="small">
                    <TableHead sx={{backgroundColor: theme.palette.primary.dark }}>
                        <TableRow>
                            <TableCell sx={{color: theme.palette.primary.contrastText }} colSpan={3}>
                                Credential Information
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody >
                        <TableRow>
                            <TableCell align="right" sx={{borderBottom:"none", borderRight: `${theme.spacing(1/8)} solid ${theme.palette.common.black}`, width: "30%"}}>
                                Credential ID:
                            </TableCell>
                            <TableCell sx={{borderBottom:"none", borderRight: `${theme.spacing(1/8)} solid ${theme.palette.common.black}`, width: "30%"}}>
                                {credentials.credentialId}
                            </TableCell>
                            <TableCell sx={{borderBottom:"none", borderRight: `${theme.spacing(1/8)} solid ${theme.palette.common.black}`, width: "30%"}} rowSpan={4}>
                                <Typography lineHeight={1.5}>
                                    This credential is based on ACT's world-renowned WorkKeys® assessments which remain the only proven system for linking job skills with workplace success. Knowledge and skills related to job tasks are the strongest predictors of work performance. By earning the NCRC, this individual has demonstrated the following skills at the Credential Level indicated on this screen:
                                </Typography>
                                <Box sx={{marginLeft: `${theme.spacing(2)}`}}>
                                    <List sx={{ listStyleType: 'disc', lineHeight: 1.25 }} >
                                        <StyledListItem dense>Problem solving</StyledListItem>
                                        <StyledListItem dense>Critical thinking</StyledListItem>
                                        <StyledListItem dense>Reading and using written, work-related text</StyledListItem>
                                        <StyledListItem dense>Applying information from workplace documents to solve problems</StyledListItem>
                                        <StyledListItem dense>Applying mathematical reasoning to work-related problems</StyledListItem>
                                        <StyledListItem dense>Setting up and performing work-related mathematical calculations</StyledListItem>
                                        <StyledListItem dense>Locating, synthesizing, and applying information that is presented graphically</StyledListItem>
                                        <StyledListItem dense>Comparing, summarizing, and analyzing information presented in multiple, related graphics</StyledListItem>
                                    </List>
                                </Box>
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell align="right" sx={{borderBottom:"none", borderRight: `${theme.spacing(1/8)} solid ${theme.palette.common.black}`}}>
                                Credential Level Description:
                            </TableCell>
                            <TableCell sx={{borderBottom:"none", borderRight: `${theme.spacing(1/8)} solid ${theme.palette.common.black}`}}>
                                {`${credentials.description}`}
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell align="right" sx={{borderBottom:"none", borderRight: `${theme.spacing(1/8)} solid ${theme.palette.common.black}`}}>
                                Credential Type:
                            </TableCell>
                            <TableCell sx={{borderBottom:"none", borderRight: `${theme.spacing(1/8)} solid ${theme.palette.common.black}`}}>
                                {`${credentials.credentialType}`}
                            </TableCell>
                        </TableRow>
                        {!isLegacy && <TableRow>
                            <TableCell align="right" sx={{borderBottom:"none", borderRight: `${theme.spacing(1/8)} solid ${theme.palette.common.black}`}}>
                                Issue Date:
                            </TableCell>
                            <TableCell sx={{borderBottom:"none", borderRight: `${theme.spacing(1/8)} solid ${theme.palette.common.black}`}}>
                                {credentials.issueDate}
                            </TableCell>
                        </TableRow>}
                    </TableBody>
                </Table>
            </TableContainer>
            <TableContainer component={Paper} sx={{marginTop: theme.spacing(4)}}>
                <Table sx={{border: `${theme.spacing(1/8)} solid ${theme.palette.common.black}`}} size="small">
                    <TableHead sx={{backgroundColor: theme.palette.primary.dark }}>
                        <TableRow>
                            <TableCell sx={{color: theme.palette.primary.contrastText }} colSpan={2}>
                                Credential Holder Information
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody >
                        <TableRow>
                            <TableCell align="right" sx={{border: `${theme.spacing(1/8)} solid ${theme.palette.common.black}`, width: "33.33%"}}>
                                First Name:
                            </TableCell>
                            <TableCell sx={{border: `${theme.spacing(1/8)} solid ${theme.palette.common.black}`, width: "66.67%"}}>
                                {credentials.firstName}
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell align="right" sx={{border: `${theme.spacing(1/8)} solid ${theme.palette.common.black}`, width: "33.33%"}}>
                                Last Name:
                            </TableCell>
                            <TableCell sx={{border: `${theme.spacing(1/8)} solid ${theme.palette.common.black}`, width: "66.67%"}}>
                                {credentials.lastName}
                            </TableCell>
                        </TableRow>
                        {!isLegacy && <TableRow>
                            <TableCell align="right" sx={{border: `${theme.spacing(1/8)} solid ${theme.palette.common.black}`, width: "33.33%"}}>
                                Middle Name:
                            </TableCell>
                            <TableCell sx={{border: `${theme.spacing(1/8)} solid ${theme.palette.common.black}`, width: "66.67%"}}>
                                {credentials.middleName}
                            </TableCell>
                        </TableRow>}
                    </TableBody>
                </Table>
            </TableContainer>
        </StyledBox>
    );
}

export default CredentialInformation;